export const SET_DOCUMENTO = 'SET_DOCUMENTO';

//sucursal
export const SET_SUCURSAL = 'SET_SUCURSAL';
export const GET_SUCURSAL = 'GET_SUCURSAL';

//carrito
export const SET_CARRITO = "SET_CARRITO";
export const GET_CARRITO = "GET_CARRITO";

//Carrito Promos
export const SET_CARRITOPROMOS = "SET_CARRITOPROMOS";
export const GET_CARRITOPROMOS = "GET_CARRITOPROMOS";

//Msal instance
export const SET_MSAL = "SET_MSAL";
export const GET_MSAL = "GET_MSAL";

//Msal instance
export const SET_CATEGORIES = "SET_CATEGORIES";
